/**
 * Serbest metin kolonlarının **bayt** genişlikleri — backend'deki
 * `com.rdc.ceosuite.common.persistence.ColumnBytes` sınıfının **aynası**.
 *
 * <p><b>Neden ayna gerekiyor:</b> sınır sunucuda `@MaxBytes` ile zorlanır (tek gerçek kapı), ama
 * kullanıcının gönderime kadar beklemeden alanın altında uyarı görmesi için istemcinin de sayıyı bilmesi
 * gerekir. İstemci Java sabitini okuyamaz.
 *
 * <p><b>İkisi birlikte değişir.</b> Kolon genişliği değişirse: DDL script'i + `ColumnBytes.java` + bu
 * dosya. Buradaki bir değer backend'den **büyük** kalırsa istemci uyarmaz ve kullanıcı yine sunucu
 * hatası alır; **küçük** kalırsa sığacak bir metni haksız yere reddeder.
 *
 * <p>Değerler `ALL_TAB_COLUMNS.CHAR_LENGTH`'ten okunmuştur (2026-09-15).
 */
export const COLUMN_BYTES = {
  /** `MEETING_MINUTES.NAME` / `DESCRIPTION` — görev, prensip kararı, gündem, karar metinleri. */
  meetingMinutesText: 4000,
  /** `MEETING.NAME` ve `MEETING.MEETING_LOCATION`. */
  meetingName: 250,
  /** `MEETING_GROUP.NAME`. */
  meetingGroupName: 250,
  /** `MEETING_GROUP.DESCRIPTION`. */
  meetingGroupDescription: 4000,
  /** `MINUTES_NOTE.NOTE` — görev notu. */
  minutesNote: 4000,
  /** `MINUTES_DEADLINE_UPDATE_REQUEST.REQUEST_NOTE` / `REJECT_NOTE`. */
  deadlineRequestNote: 4000,
  /** Katılımcı/sorumlu tablolarının `FIRST_NAME` / `LAST_NAME` kolonları. */
  personName: 100,
  /** Katılımcı/sorumlu tablolarının `BUSINESS_MAIL` kolonu. */
  businessMail: 256,
  /** Katılımcı/sorumlu tablolarının `JOB_TITLE_TR` / `JOB_TITLE_EN` kolonları. */
  jobTitle: 80,
  /** 1000 baytlık referans metin kolonları (işlem kodu adı, şablon konusu/alıcıları, açıklama). */
  referenceText: 1000,
  /** `REF_TEMPLATE_PARAMETER.NAME_TR` / `NAME_EN`. */
  templateParameterName: 100,
  /** `REF_TEMPLATE_PARAMETER.STATIC_CONTENT`. */
  templateStaticContent: 4000,
  /** `REF_PREFIX.NAME`. */
  prefixName: 255,
  /** `REF_STRATEGIC_OBJECTIVE.NAME_*` / `REF_CONTRIBUTION.NAME_*` (127) — 255 karakter / 255 bayt. */
  taskClassificationName: 255,
  /** `REF_PREFIX.PREFIX` — dar olduğu için en erken dolan alan (`ÖĞÜŞÇI` = 6 karakter, 12 bayt). */
  prefixCode: 10,
  /** `TICKET_REQUEST.NAME_SURNAME`. */
  ticketNameSurname: 255,
  /** `TICKET_REQUEST.REQUEST_NOTE` / `OTHER_REQUEST_NOTE` / `REJECT_NOTE`. */
  ticketNote: 4000,
  /** `AGENDA.TITLE` — 200 karakter / 1000 bayt. */
  agendaTitle: 1000,
  /** `AGENDA.DESCRIPTION` — 500 karakter / 1000 bayt (çok baytlı metinde bayt sınırı önce dolar). */
  agendaDescription: 1000,
  /** `AGENDA_PARTICIPANT.REASON_FOR_NON_PARTICIPATE` — 500 karakter / 2000 bayt. */
  agendaNonParticipationReason: 2000,
  /** Notlarım madde yorumu kolonu (124) — 2500 karakter / 4000 bayt (bayt sınırı önce dolabilir). */
  todoTaskDescription: 4000,
} as const
